import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
export const MissingFileExtensionsModal = (param)=>{
    let { items, onCancel, onClose, onConfirm } = param;
    const handleCancel = ()=>{
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        onClose();
    };
    const handleConfirm = ()=>{
        onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
        onClose();
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: "Missing file extensions",
        id: "missing-file-extensions",
        description: items.length < 25 ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    children: "The following files have no extension and cannot be uploaded:"
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: "m-4 list-disc",
                    children: items.map((item, index)=>/*#__PURE__*/ _jsx("li", {
                            children: item.name
                        }, index))
                }),
                /*#__PURE__*/ _jsx("span", {
                    children: "Do you want to continue uploading without these files or cancel the upload?"
                })
            ]
        }) : /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx("span", {
                children: "Some of your files do not have extensions and cannot be uploaded. Do you want to continue uploading without these files or cancel the upload?"
            })
        }),
        onDismiss: handleCancel,
        onConfirm: handleConfirm,
        isOpen: true,
        ctaSecondaryText: "Cancel",
        ctaPrimaryText: "Continue"
    });
};
